




import { Component, Vue } from "vue-property-decorator";

@Component
class StaffSurveyLayout extends Vue {}

export default StaffSurveyLayout;
